// import { JhiHttpInterceptor } from 'ng-jhipster';
import { Injectable } from '@angular/core';
import { RequestOptionsArgs, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Injector } from '@angular/core';
import { LoginService } from '../../login.service';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent
} from '@angular/common/http';

@Injectable()
export class AuthExpiredInterceptor implements HttpInterceptor {

    constructor(private injector: Injector) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        //console.log('AuthExpiredInterceptor called...');
        return next
            .handle(request)
            .do((ev: HttpEvent<any>) => {
                if (ev instanceof HttpResponse) {
                    //console.log('Auth has expired...', ev);
                    if (ev.status === 401) {
                        const loginService: LoginService = this.injector.get(LoginService);
                        loginService.logout();
                    }
                }
            });;
    }
}



// WEBPACK FOOTER //
// ./src/app/blocks/interceptor/auth-expired.interceptor.ts